import { StyledContainer } from "../components/styles/Container.styled";
import ContactForm from "../components/contactForm/ContactForm";

const Contact = () => {
  return (
    <div>
      <StyledContainer>
        <ContactForm />
      </StyledContainer>
    </div>
  );
};

export default Contact;
